import { analytics } from "@heycatch/sdk";

// Website pages report to the landing project, the signed-in app to the app project. With one key for both, it's one project.
const SITE_KEY = process.env.REACT_APP_HEYCATCH_SITE_KEY;
const APP_KEY = process.env.REACT_APP_HEYCATCH_APP_KEY;
export const HEYCATCH_SPLIT = !!SITE_KEY && !!APP_KEY && SITE_KEY !== APP_KEY;
const APP_PATH = /^\/(app|sign-in|sign-up|join|payment)(\/|$)/;
export const isAppPath = (path) => APP_PATH.test(path);
export const HEYCATCH_SURFACE = !HEYCATCH_SPLIT || isAppPath(window.location.pathname) ? "app" : "landing";

export const analyticsConsent = () => {
  const m = document.cookie.match(/(?:^|; )cr_consent=([^;]+)/);
  return !!m && (m[1] === "all" || m[1].includes("a1"));
};

analytics.init({
  projectKey: HEYCATCH_SURFACE === "app" ? APP_KEY || SITE_KEY : SITE_KEY,
  install: { framework: "react", frameworkVersion: "19", agent: "other" },
  ...(HEYCATCH_SURFACE === "landing" ? { site: "landing" } : {}),
  optOutCapturingByDefault: true,
});
if (analyticsConsent()) analytics.optInCapturing();

export const setHeyCatchConsent = (on) => (on ? analytics.optInCapturing() : analytics.optOutCapturing());

export { analytics };
